import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { cn } from '@/lib/utils';
import logo from '@/assets/images/logo.svg';
import { Link } from 'react-router-dom';

/**
 * NavBar component for non-authenticated users
 */
const NavBarPublic = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    
    window.addEventListener('scroll', handleScroll);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div
      role="banner"
      className={cn(
        'fixed top-0 left-0 right-0 z-50 transition-all duration-300 ease-in-out py-4 px-6 md:px-8',
        isScrolled ? 'glass shadow-sm' : 'bg-transparent'
      )}
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <a href="/" className="flex items-center space-x-1">
          <img
            src={logo}
            alt="logo"
            className="w-12 h-12"
          />
          <span className="text-2xl font-bold bg-gradient-to-r from-up247-700 to-up247-500 bg-clip-text text-transparent">
            up247
          </span>
        </a>

        {/* Desktop navigation links for public users */}
        <nav className="hidden md:flex items-center space-x-8">
          <a href="#features" className="text-sm font-medium text-gray-700 hover:text-up247-600 transition-colors">
            Features
          </a>
          <a href="#pricing" className="text-sm font-medium text-gray-700 hover:text-up247-600 transition-colors">
            Pricing
          </a>
          <Link to="/sign-up" className="py-2.5 px-4 text-sm font-medium text-white bg-up247-600 hover:bg-up247-700 rounded-lg transition-colors">
            Sign Up
          </Link>
        </nav>

        {/* Sign in button for public users */}
        <div className="flex items-center space-x-4">
          <Link
            to="/sign-in"
            className="py-2.5 px-4 text-sm font-medium text-white bg-up247-600 hover:bg-up247-700 rounded-lg transition-colors"
          >
            Sign In
          </Link>
          {/* Mobile menu button */}
          <button
            className="md:hidden text-gray-700"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile navigation */}
      {isMenuOpen && (
        <div className="md:hidden glass-strong absolute top-full left-0 right-0 p-4 border-t border-gray-100 animate-fade-in">
          <nav className="flex flex-col space-y-4">
            <a 
              href="#features" 
              className="text-sm font-medium text-gray-700 hover:text-up247-600 transition-colors px-2 py-2"
              onClick={() => setIsMenuOpen(false)}
            >
              Features
            </a>
            <a 
              href="#pricing" 
              className="text-sm font-medium text-gray-700 hover:text-up247-600 transition-colors px-2 py-2"
              onClick={() => setIsMenuOpen(false)}
            >
              Pricing
            </a>
            <Link
              to="/sign-up"
              className="py-2.5 px-4 text-sm font-medium text-white bg-up247-600 hover:bg-up247-700 rounded-lg transition-colors text-center"
              onClick={() => setIsMenuOpen(false)}
            >
              Sign Up
            </Link>
          </nav>
        </div>
      )}
    </div>
  );
};

export default NavBarPublic;
